import { setCookie } from 'cookies-next';
import { useRouter } from 'next/router';

import { FRONTEND_DOMAIN } from 'utils/env.utils';
import { getDefaultLocale, getLocale } from 'utils/i18n.utils';

const frontendUrl = new URL(FRONTEND_DOMAIN);
const LOCALE_COOKIE_TTL_DAYS = 365;

export const useLocale = () => {
  const router = useRouter();

  const updateLocale = (locale: string) => {
    const expires = new Date();
    expires.setDate(expires.getDate() + LOCALE_COOKIE_TTL_DAYS);

    setCookie('NEXT_LOCALE', locale, {
      sameSite: 'none',
      path: '/',
      secure: true,
      expires,
      domain: frontendUrl.hostname,
    });
  };

  return {
    locale: getLocale(router),
    defaultLocale: getDefaultLocale(router),
    updateLocale,
  };
};
